import HeaderLanding from "../layouts/HeaderLanding";
import ContentLanding from "../layouts/ContentLanding";
import { UseScrollToPeviousPosition } from "../helpers";
import ProductSection from "../layouts/ProductPreviews";

const Home = () => {
  UseScrollToPeviousPosition();

  return (
    <div className="content-wrapper">
      <HeaderLanding />
      <ContentLanding />
      <ProductSection />
    </div>
  );
};

export default Home;
